import React from 'react';

interface ErrorPageProps {
  message?: string;
}

function ErrorPage({ message = 'Página não encontrada' }: ErrorPageProps) {
  return (
    <div className="container">
      <main className="main-content" style={{ justifyContent: 'center' }}>
        <div className="vip-group-title">
          <p>{message}</p>
        </div>
      </main>
    </div>
  );
}

export default ErrorPage;
